import type { CSSProperties } from 'react';

/**
 * Props for the MUI Popover/Menu `paper` slot that turn it into CDK's `.cdk-overlay-pane` (a transparent, unstyled
 * positioning box). The Material panel then goes inside it, so rules the app wrote against Angular's overlay DOM
 * (`.cdk-overlay-pane div.mat-mdc-select-panel { ... }`) apply unchanged.
 */
export function overlayPaneProps(style: CSSProperties = {}) {
  return {
    className: 'cdk-overlay-pane',
    elevation: 0,
    style: {
      position: 'absolute' as const,
      backgroundColor: 'transparent',
      // MUI's Paper sets its own text colour; CDK's pane inherits the page's
      color: 'inherit',
      boxShadow: 'none',
      borderRadius: 0,
      overflow: 'visible',
      maxHeight: 'none',
      maxWidth: '100%',
      ...style,
    },
  };
}
